export const queryInput = (objectString) => {
    return $(`input[name="${objectString}"]`);
};

export const querySelect = (objectString) => {
    return $(`select[name="${objectString}"]`);
};

export const isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
    }
};

export const isValidState = (state) => {
    return state === 'AZ' ||
        state === 'CA' ||
        state === 'TX' ||
        state === 'NV' ||
        state === 'NM' ||
        state === 'UT';
};